module.exports = __webpack_public_path__ + "img/upload_placeholder.be2c9b3f.svg";